import script from "./newsBox.vue?vue&type=script&setup=true&lang=js"
export * from "./newsBox.vue?vue&type=script&setup=true&lang=js"

import "./newsBox.vue?vue&type=style&index=0&id=66fceeec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66fceeec"]])

export default __exports__